import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ScrapCollectionInsights } from './externalDataService.service';

export interface ScheduledTodayGlance {
  total: number;
  fulfilled: number;
  cancelled: number;
  rejected: number;
  rescheduledAway: number;
  pendingOrConfirmed: number;
}

export interface CreatedTodayGlance {
  total: number;
  viaReschedule: number;
  fulfilled: number;
  cancelled: number;
  rejected: number;
  rescheduledSince: number;
  pendingOrConfirmed: number;
  convertedViaAds: number;
  convertedViaDirectWhatsApp: number;
  withoutWhatsApp: number;
}

export interface AppointmentGlance {
  scheduledToday: ScheduledTodayGlance;
  createdToday: CreatedTodayGlance;
}

export interface AgentDutyGlance {
  onDuty: number;
  onLeave: number;
  totalActive: number;
}

export interface UnsupportedLocationGlance {
  total: number;
}

export interface DailyGlanceDto {
  newRegistrations: number;
  appointments: AppointmentGlance;
  agents: AgentDutyGlance;
  collectionInsights: ScrapCollectionInsights;
  unsupportedLocations: UnsupportedLocationGlance;
}

export interface DailyGlanceFilter {
  fromDate: string;
  toDate: string;
  geoZoneIds?: string;
}

@Injectable({ providedIn: 'root' })
export class DailyGlanceService {
  private readonly baseUrl = `${environment.apiConfig.uri}/api/DailyGlance`;

  constructor(private http: HttpClient) {}

  getDailyGlance(filter: DailyGlanceFilter): Observable<DailyGlanceDto> {
    let url = `${this.baseUrl}?fromDate=${encodeURIComponent(filter.fromDate)}&toDate=${encodeURIComponent(filter.toDate)}`;
    if (filter.geoZoneIds) {
      url += `&geoZoneIds=${encodeURIComponent(filter.geoZoneIds)}`;
    }
    return this.http.get<DailyGlanceDto>(url);
  }
}
